import { useState } from 'preact/hooks';
import { currentScreen, gameSetup } from '../../App';
import { sfx } from '../../lib/sfx';

const GENRES = [
  { id: 'action', icon: '[!]', name: { es: 'Accion', en: 'Action', pt: 'Ação' }, desc: { es: 'Combate, persecuciones, adrenalina.', en: 'Combat, chases, adrenaline.', pt: 'Combate, perseguições, adrenalina.' } },
  { id: 'drama', icon: '[~]', name: { es: 'Drama', en: 'Drama', pt: 'Drama' }, desc: { es: 'Conflictos personales, decisiones dificiles.', en: 'Personal conflicts, hard choices.', pt: 'Conflitos pessoais, escolhas difíceis.' } },
  { id: 'mystery', icon: '[?]', name: { es: 'Misterio', en: 'Mystery', pt: 'Mistério' }, desc: { es: 'Investigacion, secretos, revelaciones.', en: 'Investigation, secrets, revelations.', pt: 'Investigação, segredos, revelações.' } },
  { id: 'noir', icon: '[#]', name: { es: 'Noir', en: 'Noir', pt: 'Noir' }, desc: { es: 'Sombras, moralidad gris, traiciones.', en: 'Shadows, gray morality, betrayals.', pt: 'Sombras, moralidade cinza, traições.' } },
  { id: 'comedy', icon: '[:)]', name: { es: 'Comedia', en: 'Comedy', pt: 'Comédia' }, desc: { es: 'Humor, situaciones absurdas, ligereza.', en: 'Humor, absurd situations, lightness.', pt: 'Humor, situações absurdas, leveza.' } },
  { id: 'horror', icon: '[!!]', name: { es: 'Terror', en: 'Horror', pt: 'Terror' }, desc: { es: 'Miedo, tensiOn, amenazas desconocidas.', en: 'Fear, tension, unknown threats.', pt: 'Medo, tensão, ameaças desconhecidas.' } },
  { id: 'adventure', icon: '[>]', name: { es: 'Aventura', en: 'Adventure', pt: 'Aventura' }, desc: { es: 'Exploracion, descubrimiento, riesgo.', en: 'Exploration, discovery, risk.', pt: 'Exploração, descoberta, risco.' } },
  { id: 'fantasy_epic', icon: '[*]', name: { es: 'Fantasia Epica', en: 'Epic Fantasy', pt: 'Fantasia Épica' }, desc: { es: 'Destino, poder, batallas grandiosas.', en: 'Destiny, power, grand battles.', pt: 'Destino, poder, batalhas grandiosas.' } },
] as const;

export function GenreSelect() {
  const [selected, setSelected] = useState<string | null>(null);
  const lang = (gameSetup.value.language ?? 'en') as 'es' | 'en' | 'pt';

  const labels = {
    title: { es: 'ELIGE EL GENERO', en: 'CHOOSE THE GENRE', pt: 'ESCOLHA O GÊNERO' },
    back: { es: 'Volver', en: 'Back', pt: 'Voltar' },
    next: { es: 'Continuar', en: 'Continue', pt: 'Continuar' },
  };

  function handleConfirm() {
    if (!selected) return;
    sfx.success();
    gameSetup.value = { ...gameSetup.value, genre: selected };
    currentScreen.value = 'duration';
  }

  return (
    <div class="center-screen">
      <div class="pixel-border container">
        <h2 class="pixel-title text-yellow mb-3 text-center" style={{ fontSize: '18px' }}>
          {labels.title[lang]}
        </h2>

        <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: '0.5rem' }}>
          {GENRES.map((g) => (
            <div
              key={g.id}
              class="pixel-border"
              style={{
                cursor: 'pointer',
                padding: '0.6rem',
                borderColor: selected === g.id ? 'var(--accent-green)' : undefined,
                background: selected === g.id ? 'var(--bg-panel-light)' : undefined,
                transition: 'all 0.1s',
              }}
              onClick={() => { sfx.select(); setSelected(g.id); }}
            >
              <span class="text-yellow" style={{ fontSize: '16px' }}>{g.icon}</span>{' '}
              <span style={{ fontSize: '18px' }}>{g.name[lang]}</span>
              <p class="text-dim" style={{ fontSize: '14px', marginTop: '0.2rem' }}>{g.desc[lang]}</p>
            </div>
          ))}
        </div>

        <div class="mt-3" style={{ display: 'flex', gap: '1rem', justifyContent: 'space-between' }}>
          <button class="pixel-btn" onClick={() => { sfx.click(); currentScreen.value = 'universe'; }}>
            {labels.back[lang]}
          </button>
          <button class="pixel-btn text-green" disabled={!selected} onClick={handleConfirm}>
            {labels.next[lang]}
          </button>
        </div>
      </div>
    </div>
  );
}
